export const AUTH_SESSION_LIST_REQUEST = 'AUTH_SESSION_LIST_REQUEST'
export const AUTH_SESSION_LIST_SUCCESS = 'AUTH_SESSION_LIST_SUCCESS'
export const AUTH_SESSION_LIST_FAIL = 'AUTH_SESSION_LIST_FAIL'

export const CLEAR_ALL_COOKIES = 'CLEAR_ALL_COOKIES';
